<template>
  <div class="insurance-report-display">
    <div class="card card-default mb-4">
      <h4
        class="card-header"
        v-html="title" />
      <div class="card-body">
        <h5 v-if="insuranceReport.name">
          {{ insuranceReport.propertyAddress }}
        </h5>
        <p 
          class="text-danger"
          v-if="!insuranceReport.complete">
          <i class="fa fa-exclamation-triangle" /> Report Incomplete
        </p>
        <p class="text-muted" v-if="insuranceReport.StaffMember">
          {{ insuranceReport.StaffMember.fullName }} - <i class="far fa-clock fa-fw" /> {{ insuranceReport.createdAt | date_time_format }}
          <span class="float-right" v-if="$user.administrator"><i class="fas fa-stopwatch fa-fw" /> Time spent: {{ timeSpent }}</span>
        </p>
        <template v-if="insuranceReport.TaxInvoiceRequest">
          <p>
            <strong>
              Tax Invoice Request
            </strong>
            <br>
            <download-input
              :options="{ label: insuranceReport.TaxInvoiceRequest.referenceNumber, permalink: 'downloadFile'}"
              :value="{ objectKey: insuranceReport.TaxInvoiceRequest.InvoiceRequestPdf.objectKey }" />
          </p>
          <p v-if="insuranceReport.TaxInvoiceRequest.UploadedInvoice">
            <strong>
              Uploaded Invoice
            </strong>
            <br>
            <download-input
              :options="{ label: insuranceReport.TaxInvoiceRequest.UploadedInvoice.fileName, permalink: 'downloadFile'}"
              :value="{ objectKey: insuranceReport.TaxInvoiceRequest.UploadedInvoice.objectKey }" />
          </p>
        </template>
        <template v-if="insuranceReport.SentEmails.length">
          <sent-email
            v-for="email in insuranceReport.SentEmails"
            :key="email.uuid"
            :email="email">
          </sent-email>
        </template>
      </div>
      <div class="card-footer">
        <router-link
          :to="{ path: 'edit/' + insuranceReport.uuid, append: true }"
          class="my-1 btn btn-black">
          <i class="far fa-fw fa-edit" /> Edit
        </router-link>
        <router-link
          target="_blank"
          :to="{ path: '/api/public/pdf/' + insuranceReport.uuid + '?m=InsuranceReport' }"
          class="my-1 btn btn-secondary"
          :class="{ 'disabled': !insuranceReport.ReportPdfUuid }">
          <i class="fa fa-fw fa-search" /> Preview
        </router-link>
        <download-input
          :disabled="!insuranceReport.ReportPdfUuid"
          :options="{ button: true, permalink: 'downloadFile'}"
          :value="{ objectKey: insuranceReport.ReportPdf ? insuranceReport.ReportPdf.objectKey : '' }" />
        <button 
          class="my-1 btn btn-primary" 
          @click="generatePdf()">
          <i class="fa fa-fw fa-redo-alt" /> Generate PDF
        </button>
        <button 
          class="my-1 btn btn-success" 
          @click="send()" 
          :disabled="!insuranceReport.complete">
          <i class="far fa-fw fa-paper-plane" /> Send
        </button>
        <button 
          class="my-1 btn btn-lime" 
          @click="duplicate()">
          <i class="far fa-fw fa-copy" /> Duplicate
        </button>
        <router-link 
          :to="'/tax-invoice-requests/new/' + insuranceReport.uuid + '?t=InsuranceReport'"
          class="my-1 btn btn-warning"
          :class="{ 'disabled': !generateInvoiceButton }">
          <i class="fa fa-fw fa-dollar-sign" /> Invoice Request
        </router-link>
        <button 
          @click="deleteInsuranceReport()" 
          class="my-1 btn btn-danger">
          <i class="fa fa-fw fa-trash" /> Delete
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    DELETE_REPORT,
    DUPLICATE_INSURANCE_REPORT,
    GENERATE_INSURANCE_PDF,
    SEND_INSURANCE_REPORT
  } from '@/vuex/types'
  import SentEmail from '@/components/displays/SentEmail'
  import DownloadInput from '@/components/inputs/DownloadInput'
  export default {
    name: 'InsuranceReportDisplay',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      SentEmail,
      DownloadInput
    },
    computed: {
      timeSpent () {
        let minutes = this.insuranceReport.time / 60.0
        if (minutes > 120) {
          let hours = minutes / 60
          return hours.toFixed(2) + ' hours'
        } else {
          return minutes.toFixed(2) + ' min'
        }
      },
      fileName () {
        if (this.insuranceReport.ReportPdf) {
          return this.insuranceReport.ReportPdf.fileName.slice(0, -4)
        } else {
          return this.insuranceReport.propertyAddress
        }
      },
      generateInvoiceButton () {
        return this.insuranceReport.complete && !this.insuranceReport.TaxInvoiceRequestUuid
      },
      title () {
        if (this.insuranceReport.name) {
          return '<i class="fa fa-fw fa-file"></i> ' + this.insuranceReport.name
        } else if (this.insuranceReport.propertyAddress) {
          return '<i class="fa fa-fw fa-map-marker-alt"></i> ' + this.insuranceReport.propertyAddress
        } else {
          return '<i class="fa fa-fw fa-certificate"></i> New Report'
        }
      },
      insuranceReport () {
        return {
          StaffMember: {},
          ...this.object
        }
      }
    },
    methods: {
      async deleteInsuranceReport () {
        await this.$store.dispatch(DELETE_REPORT, {
          reportUuid: this.insuranceReport.uuid,
          reportType: 'InsuranceReport'
        })
      },
      async generatePdf () {
        await this.$store.dispatch(GENERATE_INSURANCE_PDF, this.insuranceReport)
      },
      async duplicate () {
        await this.$store.dispatch(DUPLICATE_INSURANCE_REPORT, this.insuranceReport.uuid)
      },
      async send () {
        await this.$store.dispatch(SEND_INSURANCE_REPORT, this.insuranceReport.uuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cards/InsuranceReport.vue